import { ChainId, JSBI, Percent, Token, WETH } from '@pancakeswap-libs/sdk'
import { AbstractConnector } from '@web3-react/abstract-connector'

import { injected, NETWORK_CHAIN_ID } from '../connectors'
import { pinnedPairs, pinnedStableCoinPairs } from './token'

// TODO
export const ROUTER_ADDRESS = (function() {
  if (NETWORK_CHAIN_ID === ChainId.HECO_MAINNET) {
    // ht的pancake
    return '0xed7d5f38c79115ca12fe6c0041abb22f0a06c300'
  }

  if (NETWORK_CHAIN_ID === ChainId.OEC_MAINNET) {
    return '0x865bfde337c8afbfff144ff4c29f9404ebb22b15'
  }
  if(NETWORK_CHAIN_ID===ChainId.CORE_MAINNET){
    return '0xE9bA194995E9286a94c61F6436EdaE368810543b'
  }

  if (NETWORK_CHAIN_ID === ChainId.POLYGON) {
    return '0xa5e0829caced8ffdd4de3c43696c57f7d7a678ff'
  }
  if (NETWORK_CHAIN_ID === ChainId.BSC_MAINNET) {
    return '0x10ED43C718714eb63d5aA57B78B54704E256024E'
  }
  if (NETWORK_CHAIN_ID === ChainId.BSC_TESTNET) {
    return '0x9ac64cc6e4415144c455bd8e4837fea55603e5c3'
  }
})()

// a list of tokens by chain
type ChainTokenList = {
  readonly [chainId in ChainId]: Token[]
}

export const HUSD = new Token(
  ChainId.HECO_MAINNET,
  '0x0298c2b32eae4da002a15f36fdf7615bea3da047',
  8,
  'HUSD',
  'Heco-Peg HUSD Token'
)

export const USDT = new Token(
  ChainId.HECO_MAINNET,
  '0xa71edc38d189767582c38a3145b5873052c3e47a',
  18,
  'USDT',
  'Heco-Peg USDTHECO Token'
)

export const ETH = new Token(
  ChainId.HECO_MAINNET,
  '0x64ff637fb478863b7468bc97d30a5bf3a428a1fd',
  18,
  'ETH',
  'Heco-Peg ETH Token'
)

const WETH_ONLY: ChainTokenList = {
  [ChainId.HECO_MAINNET]: [WETH[ChainId.HECO_MAINNET]],
  [ChainId.OEC_MAINNET]: [WETH[ChainId.OEC_MAINNET]],
  [ChainId.CORE_MAINNET]:[WETH[ChainId.CORE_MAINNET]],
  [ChainId.HECO_TESTNET]: [WETH[ChainId.HECO_TESTNET]],
  [ChainId.POLYGON]: [WETH[ChainId.POLYGON]],
  [ChainId.BSC_MAINNET]: [WETH[ChainId.BSC_MAINNET]],
  [ChainId.BSC_TESTNET]: [WETH[ChainId.BSC_TESTNET]]
}

export const NERWORK_URLS = {
  [ChainId.HECO_MAINNET]: 'https://http-mainnet-node.defibox.com/',
  [ChainId.OEC_MAINNET]: 'https://exchainrpc.okex.org/',
  [ChainId.CORE_MAINNET]:'https://rpc.coredao.org/',
  [ChainId.POLYGON]: 'https://rpc-mainnet.maticvigil.com/',
  [ChainId.BSC_MAINNET]: 'https://bsc-dataseed.binance.org/',
  [ChainId.BSC_TESTNET]: 'https://data-seed-prebsc-1-s1.binance.org:8545'
}

export const EXPLORER_URLS = {
  [ChainId.HECO_MAINNET]: 'https://hecoinfo.com',
  [ChainId.OEC_MAINNET]: 'https://www.oklink.com/okexchain',
  [ChainId.CORE_MAINNET]:'https://scan.coredao.org',
  [ChainId.POLYGON]: 'https://polygonscan.com/',
  [ChainId.BSC_MAINNET]: 'https://bscscan.com/',
  [ChainId.BSC_TESTNET]: 'https://testnet.bscscan.com/'
}

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WETH_ONLY,
  [NETWORK_CHAIN_ID]: [...WETH_ONLY[NETWORK_CHAIN_ID], ...pinnedStableCoinPairs()]
}

/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
export const CUSTOM_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [NETWORK_CHAIN_ID]: {
    [ETH.address]: [HUSD, WETH[NETWORK_CHAIN_ID]]
  }
}

// used for display in the default list when adding liquidity
export const SUGGESTED_BASES: ChainTokenList = {
  ...WETH_ONLY,
  [NETWORK_CHAIN_ID]: [...WETH_ONLY[NETWORK_CHAIN_ID], ...pinnedStableCoinPairs()]
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  ...WETH_ONLY,
  [NETWORK_CHAIN_ID]: [...WETH_ONLY[NETWORK_CHAIN_ID], ...pinnedStableCoinPairs()]
}

export const PINNED_PAIRS: { readonly [chainId in ChainId]?: [Token, Token][] } = {
  [NETWORK_CHAIN_ID]: [pinnedPairs(), pinnedStableCoinPairs()]
}

export interface WalletInfo {
  connector?: AbstractConnector
  name: string
  iconName: string
  description: string
  href: string | null
  color: string
  primary?: true
  mobile?: true
  mobileOnly?: true
}

export const SUPPORTED_WALLETS: { [key: string]: WalletInfo } = {
  INJECTED: {
    connector: injected,
    name: 'Injected',
    iconName: 'arrow-right.svg',
    description: 'Injected web3 provider.',
    href: null,
    color: '#010101',
    primary: true
  },
  METAMASK: {
    connector: injected,
    name: 'MetaMask',
    iconName: 'metamask.png',
    description: 'Easy-to-use browser extension.',
    href: null,
    color: '#E8831D'
  }
  // WALLET_CONNECT: {
  //   connector: walletconnect,
  //   name: 'WalletConnect',
  //   iconName: 'walletConnectIcon.svg',
  //   description: 'Connect to Trust Wallet, Rainbow Wallet and more...',
  //   href: null,
  //   color: '#4196FC',
  //   mobile: true
  // },
  // WALLET_LINK: {
  //   connector: walletlink,
  //   name: 'Coinbase Wallet',
  //   iconName: 'coinbaseWalletIcon.svg',
  //   description: 'Use Coinbase Wallet app on mobile device',
  //   href: null,
  //   color: '#315CF5'
  // },
  // COINBASE_LINK: {
  //   name: 'Open in Coinbase Wallet',
  //   iconName: 'coinbaseWalletIcon.svg',
  //   description: 'Open in Coinbase Wallet app.',
  //   href: 'https://go.cb-w.com/mtUDhEZPy1',
  //   color: '#315CF5',
  //   mobile: true,
  //   mobileOnly: true
  // },
  // FORTMATIC: {
  //   connector: fortmatic,
  //   name: 'Fortmatic',
  //   iconName: 'fortmaticIcon.png',
  //   description: 'Login using Fortmatic hosted wallet',
  //   href: null,
  //   color: '#6748FF',
  //   mobile: true
  // },
  // Portis: {
  //   connector: portis,
  //   name: 'Portis',
  //   iconName: 'portisIcon.png',
  //   description: 'Login using Portis hosted wallet',
  //   href: null,
  //   color: '#4A6C9B',
  //   mobile: true
  // }
}

export const NetworkContextName = 'NETWORK'

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 50
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

// one basis point
export const ONE_BIPS = new Percent(JSBI.BigInt(1), JSBI.BigInt(10000))
export const BIPS_BASE = JSBI.BigInt(10000)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%

// used to ensure the user doesn't send so much ETH so they end up with <.01
export const MIN_ETH: JSBI = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16)) // .01 ETH
export const BETTER_TRADE_LINK_THRESHOLD = new Percent(JSBI.BigInt(75), JSBI.BigInt(10000))
